import IdleVue from 'idle-vue';
import store   from '../store';
import Vue     from 'vue'

const eventsHub = new Vue()

export default {
    install: function(Vue) {
        Vue.use(IdleVue, {
            eventEmitter: eventsHub,
            idleTime: process.env.VUE_APP_IDLE_TIMEOUT,
            store
        })
    }
}